 function showFields(layoutType) {
              document.getElementById('rectFields').style.display = layoutType === 'Rectangular' ? 'block' : 'none';
              document.getElementById('cornerFields').style.display = layoutType === 'Corner' ? 'block' : 'none';
          }
      // Simplified sprinkler data
      const sprinklerData = {
      "R3": {
          1.5: { 45: { "Flow Rate (l/h)": 70, "Radius (m)": 3.0 }, 90: { "Flow Rate (l/h)": 110, "Radius (m)": 3.0 }, 180: { "Flow Rate (l/h)": 220, "Radius (m)": 3.0 }, 270: { "Flow Rate (l/h)": 340, "Radius (m)": 3.0 }, 360: { "Flow Rate (l/h)": 420, "Radius (m)": 3.0 } },
          2.0: { 45: { "Flow Rate (l/h)": 70, "Radius (m)": 3.1 }, 90: { "Flow Rate (l/h)": 120, "Radius (m)": 3.1 }, 180: { "Flow Rate (l/h)": 250, "Radius (m)": 3.1 }, 270: { "Flow Rate (l/h)": 380, "Radius (m)": 3.1 }, 360: { "Flow Rate (l/h)": 480, "Radius (m)": 3.1 } },
          2.5: { 45: { "Flow Rate (l/h)": 80, "Radius (m)": 3.2 }, 90: { "Flow Rate (l/h)": 140, "Radius (m)": 3.2 }, 180: { "Flow Rate (l/h)": 270, "Radius (m)": 3.2 }, 270: { "Flow Rate (l/h)": 410, "Radius (m)": 3.2 }, 360: { "Flow Rate (l/h)": 540, "Radius (m)": 3.2 } }
      },
      "R4": {
          1.5: { 45: { "Flow Rate (l/h)": 80, "Radius (m)": 4.0 }, 90: { "Flow Rate (l/h)": 140, "Radius (m)": 4.0 }, 180: { "Flow Rate (l/h)": 270, "Radius (m)": 4.0 }, 270: { "Flow Rate (l/h)": 420, "Radius (m)": 4.0 }, 360: { "Flow Rate (l/h)": 540, "Radius (m)": 4.0 } },
          2.0: { 45: { "Flow Rate (l/h)": 90, "Radius (m)": 4.2 }, 90: { "Flow Rate (l/h)": 160, "Radius (m)": 4.2 }, 180: { "Flow Rate (l/h)": 310, "Radius (m)": 4.2 }, 270: { "Flow Rate (l/h)": 480, "Radius (m)": 4.2 }, 360: { "Flow Rate (l/h)": 620, "Radius (m)": 4.2 } },
          2.5: { 45: { "Flow Rate (l/h)": 110, "Radius (m)": 4.4 }, 90: { "Flow Rate (l/h)": 190, "Radius (m)": 4.4 }, 180: { "Flow Rate (l/h)": 370, "Radius (m)": 4.4 }, 270: { "Flow Rate (l/h)": 570, "Radius (m)": 4.4 }, 360: { "Flow Rate (l/h)": 720, "Radius (m)": 4.4 } }
      },
      "R4,5": {
          1.5: { 45: { "Flow Rate (l/h)": 80, "Radius (m)": 4.5 }, 90: { "Flow Rate (l/h)": 160, "Radius (m)": 4.5 }, 180: { "Flow Rate (l/h)": 310, "Radius (m)": 4.5 }, 270: { "Flow Rate (l/h)": 490, "Radius (m)": 4.5 }, 360: { "Flow Rate (l/h)": 600, "Radius (m)": 4.5 } },
          2.0: { 45: { "Flow Rate (l/h)": 110, "Radius (m)": 4.7 }, 90: { "Flow Rate (l/h)": 180, "Radius (m)": 4.7 }, 180: { "Flow Rate (l/h)": 360, "Radius (m)": 4.7 }, 270: { "Flow Rate (l/h)": 560, "Radius (m)": 4.7 }, 360: { "Flow Rate (l/h)": 700, "Radius (m)": 4.7 } },
          2.5: { 45: { "Flow Rate (l/h)": 130, "Radius (m)": 4.9 }, 90: { "Flow Rate (l/h)": 230, "Radius (m)": 4.9 }, 180: { "Flow Rate (l/h)": 410, "Radius (m)": 4.9 }, 270: { "Flow Rate (l/h)": 660, "Radius (m)": 4.9 }, 360: { "Flow Rate (l/h)": 810, "Radius (m)": 4.9 } }
      },
      "R5": {
          1.5: { 45: { "Flow Rate (l/h)": 190, "Radius (m)": 5.0 }, 90: { "Flow Rate (l/h)": 260, "Radius (m)": 5.0 }, 180: { "Flow Rate (l/h)": 440, "Radius (m)": 5.0 }, 270: { "Flow Rate (l/h)": 590, "Radius (m)": 5.0 }, 360: { "Flow Rate (l/h)": 680, "Radius (m)": 5.0 } },
          2.0: { 45: { "Flow Rate (l/h)": 190, "Radius (m)": 5.3 }, 90: { "Flow Rate (l/h)": 300, "Radius (m)": 5.3 }, 180: { "Flow Rate (l/h)": 500, "Radius (m)": 5.3 }, 270: { "Flow Rate (l/h)": 620, "Radius (m)": 5.3 }, 360: { "Flow Rate (l/h)": 800, "Radius (m)": 5.3 } },
          2.5: { 45: { "Flow Rate (l/h)": 230, "Radius (m)": 5.6 }, 90: { "Flow Rate (l/h)": 330, "Radius (m)": 5.6 }, 180: { "Flow Rate (l/h)": 540, "Radius (m)": 5.6 }, 270: { "Flow Rate (l/h)": 710, "Radius (m)": 5.6 }, 360: { "Flow Rate (l/h)": 910, "Radius (m)": 5.6 } }
      }
  };
  
  
      // Function to calculate flow rate from bucket test
      function calculateFlowRate(timeToFill, bucketSize) {
          return (bucketSize / timeToFill) * 3600;
      }
  
      function calculate() {
      const timeToFill = parseFloat(document.getElementById("timeToFill").value);
      const bucketSize = parseFloat(document.getElementById("bucketSize").value);
      const numSprinklers = parseInt(document.getElementById("popupCount").value);
      const desiredRadius = 5;
  
      const tapFlowRate = calculateFlowRate(timeToFill, bucketSize);
  
      const pressureScenarios = [1.5, 2.0, 2.5]; // Low, Medium, High pressures in bar
      const results = [];
  
      for (const pressure of pressureScenarios) {
          let bestMatch = null;
  
          // Find the best nozzle match that satisfies the desired radius and pressure
          for (const [type, dataByPressure] of Object.entries(sprinklerData)) {
              const dataByAngle = dataByPressure[pressure];
              if (!dataByAngle) continue;
  
              for (const [angle, data] of Object.entries(dataByAngle)) {
                  if (data["Radius (m)"] >= desiredRadius) {
                      bestMatch = { type, pressure, angle, ...data };
                      break;
                  }
              }
              if (bestMatch) break;
          }
  
          // Calculate the required flow rate for this pressure scenario
          const requiredFlowRate = bestMatch ? bestMatch["Flow Rate (l/h)"] * numSprinklers : 0;
  
          results.push({
              pressure,
              bestMatch,
              requiredFlowRate,
              isSufficient: tapFlowRate >= requiredFlowRate
          });
      }
  
      const resultsDiv = document.getElementById("resultsDiv");
  let headerHtml = '<tr><th>Pressure (bar)</th>';
  let requiredFlowRateHtml = '<tr><td>Required Flow Rate (L/h)</td>';
  let expectedRadiusHtml = '<tr><td>Expected Radius (m)</td>';
  let suggestedNozzleHtml = '<tr><td>Suggested Nozzle</td>';
  let sufficiencyHtml = '<tr><td>Flow Rate Sufficiency</td>';
  
  for (const { pressure, bestMatch, requiredFlowRate, isSufficient } of results) {
      headerHtml += `<th>${pressure}</th>`;
      requiredFlowRateHtml += `<td>${requiredFlowRate}</td>`;
      expectedRadiusHtml += `<td>${bestMatch ? bestMatch["Radius (m)"] : 'N/A'}</td>`;
      suggestedNozzleHtml += `<td>${bestMatch ? `Type: ${bestMatch.type}, Angle: ${bestMatch.angle}` : 'N/A'}</td>`;
      sufficiencyHtml += `<td>${isSufficient ? 'Sufficient' : 'Insufficient'}</td>`;
  }
  
  headerHtml += '</tr>';
  requiredFlowRateHtml += '</tr>';
  expectedRadiusHtml += '</tr>';
  suggestedNozzleHtml += '</tr>';
  sufficiencyHtml += '</tr>';
  
  const tableHtml = `
      <p>Available Flow Rate: ${tapFlowRate.toFixed(2)} L/h</p>
      <table border="1">
          ${headerHtml}
          ${requiredFlowRateHtml}
          ${expectedRadiusHtml}
          ${suggestedNozzleHtml}
          ${sufficiencyHtml}
      </table>
  `;
  $('#resultsDiv').show();
  $('#resultsHTML').html(tableHtml);
  
  
  }
  
    function calculateSprinklers() {
      $('#step2').show();
      const selectedLayout = document.querySelector('input[name="layoutType"]:checked');
      let layoutType;
      if (selectedLayout) {
          layoutType = selectedLayout.value;
      } else {
          // Alert the user that they need to select a layout type
          alert('Please select a layout type.');
      }
  
     const length = parseFloat(document.getElementById("rectLength").value);
      const width = parseFloat(document.getElementById("rectWidth").value);
      const totalArea = length * width;
  
      const desiredRadius = 5;
      const overlap = 30;
      const effectiveRadius = desiredRadius * (1 - overlap / 100);
      const fullCoverageArea = Math.PI * Math.pow(effectiveRadius, 2);
      const halfCoverageArea = fullCoverageArea / 2;
      const quarterCoverageArea = fullCoverageArea / 4;
  
      // Calculate number of sprinklers along each edge
      const numEdgeLength = Math.floor(length / (2 * effectiveRadius));
      const numEdgeWidth = Math.floor(width / (2 * effectiveRadius));
  
      // Initialize total effective coverage area with corner and edge sprinklers
      let totalCoverage = 4 * quarterCoverageArea + numEdgeLength * halfCoverageArea + numEdgeWidth * halfCoverageArea;
  
      // Initialize the number of sprinklers with corner and edge sprinklers
      let numSprinklers = 4 + numEdgeLength + numEdgeWidth;
  
      // Add sprinklers to the center until full coverage is achieved
      while (totalCoverage < totalArea) {
          totalCoverage += fullCoverageArea;
          numSprinklers += 1;
      }
      $('#popupCount').val(numSprinklers);
      $('#layoutResults').show(); 
      let html = `<p>You will need approximately ${numSprinklers} sprinklers to cover your ${layoutType} garden layout.</p>`;
      $('#layoutResultsHTML').html(html);
  }